var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"600","outlined":""}},[_c('card-toolbar',{staticClass:"mt-4 mb-3",attrs:{"back-button-route":_vm.backButtonRoute,"back-button-tooltip":_vm.backButtonTooltip,"icon":_vm.NOT_FOUND_ICON,"title":_vm.text,"button-mode":"","include-back":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }